/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1SsoimageMutationRequest,
  PostApiV1SsoimageMutationResponse,
  PostApiV1Ssoimage400,
  PostApiV1Ssoimage401,
  PostApiV1Ssoimage500,
} from "../../types/SSOImageController/PostApiV1Ssoimage.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1Ssoimage } from "../../clients/SSOImageController/postApiV1Ssoimage.ts";

export const postApiV1SsoimageMutationKey = () =>
  [{ url: "/api/v1/ssoimage" }] as const;

export type PostApiV1SsoimageMutationKey = ReturnType<
  typeof postApiV1SsoimageMutationKey
>;

export function postApiV1SsoimageMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1SsoimageMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1SsoimageMutationKey();
  return mutationOptions<
    PostApiV1SsoimageMutationResponse,
    ResponseErrorConfig<
      PostApiV1Ssoimage400 | PostApiV1Ssoimage401 | PostApiV1Ssoimage500
    >,
    { data: PostApiV1SsoimageMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1Ssoimage(data, config);
    },
  });
}

/**
 * @description Cria uma nova SSOImage com seus idiomas. O conteúdo de cada idioma é salvo no Azure Blob Storage antes da confirmação no banco. **(Requer Authorization para autenticação)**
 * @summary Criar imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage}
 */
export function usePostApiV1Ssoimage<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1SsoimageMutationResponse,
      ResponseErrorConfig<
        PostApiV1Ssoimage400 | PostApiV1Ssoimage401 | PostApiV1Ssoimage500
      >,
      { data: PostApiV1SsoimageMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1SsoimageMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1SsoimageMutationKey();

  const baseOptions = postApiV1SsoimageMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1SsoimageMutationResponse,
    ResponseErrorConfig<
      PostApiV1Ssoimage400 | PostApiV1Ssoimage401 | PostApiV1Ssoimage500
    >,
    { data: PostApiV1SsoimageMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1SsoimageMutationResponse,
    ResponseErrorConfig<
      PostApiV1Ssoimage400 | PostApiV1Ssoimage401 | PostApiV1Ssoimage500
    >,
    { data: PostApiV1SsoimageMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1SsoimageMutationResponse,
    ResponseErrorConfig<
      PostApiV1Ssoimage400 | PostApiV1Ssoimage401 | PostApiV1Ssoimage500
    >,
    { data: PostApiV1SsoimageMutationRequest },
    TContext
  >;
}
